module.exports = __webpack_public_path__ + "9b0a51073b6f5af584a072754aa4f069.svg";